import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface PhonePrefix {
    code: string;
    prefix: string;
    url: string;
    nameTranslated?: string;
}

const PHONE_PREFIX_DATA: readonly PhonePrefix[] = [
    { code: 'AD', prefix: '+376', url: '/assets/images/flags/andorra.webp' },
    { code: 'CL', prefix: '+56', url: '/assets/images/flags/chile.webp' },
    { code: 'CR', prefix: '+506', url: '/assets/images/flags/costa_rica.png' },
    { code: 'DE', prefix: '+49', url: '/assets/images/flags/germany.webp' },
    { code: 'ES', prefix: '+34', url: '/assets/images/flags/spain.webp' },
    { code: 'FR', prefix: '+33', url: '/assets/images/flags/france.webp' },
    { code: 'GB', prefix: '+44', url: '/assets/images/flags/united_kingdom.webp' },
    { code: 'IT', prefix: '+39', url: '/assets/images/flags/italy.webp' },
    { code: 'NL', prefix: '+31', url: '/assets/images/flags/netherlands.webp' },
    { code: 'PT', prefix: '+351', url: '/assets/images/flags/portugal.webp' },
    { code: 'TW', prefix: '+886', url: '/assets/images/flags/taiwan.png' },
    { code: 'US', prefix: '+1', url: '/assets/images/flags/united-states.webp' },
];

@Injectable({
    providedIn: 'root',
})
export class PhonePrefixService {
    private phonePrefixesWithTranslations: PhonePrefix[] = [];
    private sortedCache: PhonePrefix[] | null = null;

    constructor(private translateService: TranslateService) {
        this.initializePrefixes();
        this.translateService.onLangChange.subscribe(() => {
            this.sortedCache = null;
            this.initializePrefixes();
        });
    }

    private initializePrefixes(): void {
        this.phonePrefixesWithTranslations = PHONE_PREFIX_DATA.map(prefix => ({
            ...prefix,
            nameTranslated: this.translateService.instant(`flag_country.${prefix.code}`)
        }));
        this.sortedCache = null;
    }

    getPhonePrefixesSorted(): PhonePrefix[] {
        if (this.sortedCache) {
            return this.sortedCache;
        }

        this.sortedCache = [...this.phonePrefixesWithTranslations].sort((a, b) => {
            const aName = (a.nameTranslated ?? a.code).toString();
            const bName = (b.nameTranslated ?? b.code).toString();
            return aName.localeCompare(bName, undefined, { numeric: true, sensitivity: 'base' });
        });
        return this.sortedCache;
    }

    getPhonePrefixes(): PhonePrefix[] {
        return [...this.phonePrefixesWithTranslations];
    }

    getPrefixByCode(code: string): PhonePrefix | undefined {
        return this.phonePrefixesWithTranslations.find(p => p.code === code);
    }
}
